import { useEffect } from 'react'
import { usePageState } from '../../context/page-context'
import { Outlet } from 'react-router-dom'
import { useTitleChange } from '@msaf/core-react'

export default function Administration() {
  useTitleChange('Administration')
  const { setPageState } = usePageState()

  useEffect(() => {
    setPageState({
      heading: 'Administration',
      headerTabs: [
        {
          label: 'Users',
          path: `/admin/users`,
        },
        {
          label: 'Organisations',
          path: `/admin/organisations`,
        },
      ],
    })
    // Reset page state on unmount
    return () => setPageState({})
  }, [setPageState])

  return <Outlet />
}
